import { useApiClient } from '@/composables/useApiClient'
import * as OrderService from '@/service/order'

export const state = () => ({
  orders: [],
  totalOrdersCount: 0,
})

export const getters = {
  orders: state => state.orders,
  totalOrdersCount: state => state.totalOrdersCount,
}

export const actions = {
  getUserOrders({ commit }, { start = 0, size = 12, finish = 2, order_sources = [], branchId = '' }) {
    const query = new URLSearchParams()
    query.append('start', start)
    query.append('size', size)
    query.append('finish', finish)
    if (branchId) {
      query.append('branch_id', branchId)
    }
    order_sources.forEach(source => query.append('order_sources[]', source))
    const url = `/order?${decodeURIComponent(query.toString())}`
    return useApiClient()
      .$get(url)
      .then(res => {
        if (res.code === 0) {
          commit('SET_USER_ORDERS', res.data)
          commit('SET_TOTAL_ORDERS_COUNT', res.total_count)
        }
        return res
      })
      .catch(error => {
        console.error('getUserOrders:error', error)
        return error
      })
  },
  getOrderDetail({ commit }, orderID) {
    return OrderService.getOrderDetail(useApiClient(), { orderID })
  },
  cancelOrder({ commit }, orderId) {
    const apiUrl = `/order/${orderId}/cancel`
    const data = {}
    return useApiClient()
      .$post(apiUrl, data)
      .catch(error => {
        console.log('order/cancelOrder:error', error)
        return error
      })
  },
  visibleOrder({ commit }, orderId) {
    const apiUrl = `order/${orderId}/visible`
    const data = { status: 1 }
    return useApiClient()
      .$post(apiUrl, data)
      .catch(error => {
        console.log('order/visibleOrder:error', error)
        return error
      })
  },
}

export const mutations = {
  SET_USER_ORDERS(state, userOrders) {
    state.orders = userOrders
  },
  SET_TOTAL_ORDERS_COUNT(state, totalOrdersCount) {
    state.totalOrdersCount = totalOrdersCount
  },
}
